import { render, staticRenderFns } from "./WatchViewForm.vue?vue&type=template&id=5b947fa1&scoped=true"
import script from "./WatchViewForm.vue?vue&type=script&lang=js"
export * from "./WatchViewForm.vue?vue&type=script&lang=js"
import style0 from "./WatchViewForm.vue?vue&type=style&index=0&id=5b947fa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b947fa1",
  null
  
)

export default component.exports